import { Grid, Typography, makeStyles } from '@material-ui/core';
import React from 'react';
import FlagColombia from '../../../../Components/CustomIcons/Flags/FlagColombia';
import ControlledNumberInput from '../../../../Components/Controlled/ControlledNumberInput';

const PhoneValidationChallenge = props => {
  const { id, description, loading, control, formHelpers } = props;

  const classes = useStyles();

  return (
    <div key={id}>
      <Grid container>
        <Grid item xs={12} sm={6} className={classes.questionText}>
          <Typography>{description}</Typography>
        </Grid>
        <Grid item xs={12} sm={6} container justifyContent="center">
          <Grid item xs={5} sm={5} className={classes.countryCodeInput}>
            <ControlledNumberInput
              control={control}
              name={formHelpers.getFieldPath(id, 'phoneCountryCode')}
              defaultValue="57"
              id="PhoneValidationChallenge_input_phoneCountryCode"
              autoComplete="tel-country-code"
              required
              InputProps={{
                startAdornment: (
                  <FlagColombia size={20} style={{ flexShrink: 0 }} />
                )
              }}
              format="+###"
              placeholder="57"
              fullWidth
              label="Prefijo"
              disabled={loading}
              error={Boolean(formHelpers.getFieldError(id, 'phoneCountryCode'))}
              helperText={formHelpers.getFieldErrorMessage(
                id,
                'phoneCountryCode'
              )}
              margin="none"
            />
          </Grid>
          <Grid item xs={7} sm={7}>
            <ControlledNumberInput
              control={control}
              name={formHelpers.getFieldPath(id, 'phone')}
              id="PhoneValidationChallenge_input_phone"
              autoComplete="tel-local"
              required
              fullWidth
              margin="none"
              label="Número celular"
              disabled={loading}
              error={Boolean(formHelpers.getFieldError(id, 'phone'))}
              helperText={formHelpers.getFieldErrorMessage(id, 'phone')}
            />
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

const useStyles = makeStyles(theme => ({
  sectionText: {
    margin: theme.spacing(2, 0, 3, 0)
  },
  questionContainer: {
    marginBottom: theme.spacing()
  },
  questionText: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: theme.spacing(0.5),
    [theme.breakpoints.down(600)]: {
      paddingBottom: theme.spacing(2)
    }
  },
  month: {
    fontWeight: 500
  },
  countryCodeInput: { paddingRight: theme.spacing(2) }
}));

export default PhoneValidationChallenge;
